import { FaArrowRight } from "react-icons/fa";

import "./two-sides-box.css";
import { Fragment } from "react/jsx-runtime";

const TwoSidesBox = ({ side1, side2 }) => {
  // console.log({ side1, side2 });

  const formattedContent = [side1, side2];

  return (
    <section className="centered-section">
      <div className="two-sides-box">
        {formattedContent.map((content, index) => {
          const { imageURL, title, subtitle, button } = content || {};
          return (
            <Fragment key={`side-${index}`}>
              <div className="two-sides-layout">
                <img className="two-sides-img" src={imageURL} alt="button-1" />
                <div className="two-sides-box-column">
                  <p className="two-sides-title">{title}</p>
                  <div className="horizontal">
                    <p className="card-text">{subtitle}</p>
                  </div>
                  {button?.payload ? (
                    button.payload
                  ) : button?.text ? (
                    <button
                      onClick={button?.onChange}
                      className={
                        "boton-generico " +
                        (button?.className ? button.className : "")
                      }
                      style={{ marginTop: "2rem" }}
                    >
                      <p>{button?.text}</p>
                      <FaArrowRight />
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {index === 0 && <div className="two-sides-divider" />}
            </Fragment>
          );
        })}
      </div>
    </section>
  );
};

export default TwoSidesBox;
